module.exports = __webpack_public_path__ + "static/media/peinture.117947db.svg";